import { render } from "./CustomTab.vue?vue&type=template&id=75b066d8&scoped=true"
import script from "./CustomTab.vue?vue&type=script&lang=js"
export * from "./CustomTab.vue?vue&type=script&lang=js"

import "./CustomTab.vue?vue&type=style&index=0&id=75b066d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b066d8"]])

export default __exports__